// Remove retired conditions from bookmarked URLs without changing shared Shopify data.
if (!customElements.get('ac-facet-options')) {
  customElements.define('ac-facet-options', class extends HTMLElement {
    connectedCallback() {
      const url = new URL(window.location.href);
      const retiredSorts = ['best-selling', 'title-ascending', 'title-descending', 'created-ascending'];
      const retiredFilters = ['filter.p.m.custom.sales-type', 'filter.v.price.gte', 'filter.v.price.lte'];
      let changed = false;
      retiredFilters.forEach((name) => {
        if (url.searchParams.has(name)) changed = true;
        url.searchParams.delete(name);
      });
      if (retiredSorts.includes(url.searchParams.get('sort_by') || this.dataset.sortBy)) {
        url.searchParams.set('sort_by', this.dataset.fallbackSort);
        changed = true;
      }
      if (!changed) return;
      url.searchParams.delete('page');
      const theme = window.Shopify?.theme;
      if (theme?.id && theme.role !== 'main') url.searchParams.set('preview_theme_id', theme.id);
      window.location.replace(url.toString());
    }
  });
}
